import { render, staticRenderFns } from "./EditMaterial.vue?vue&type=template&id=2f414cca"
import script from "./EditMaterial.vue?vue&type=script&lang=js"
export * from "./EditMaterial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports